import { useState } from 'react';
import clsx from 'clsx';
import DropdownButton from 'components/Button/DropdownButton/DropdownButton';
import APResponsiveDropdown from 'components/Dropdown/APResponsiveDropdown';
import DeleteConfirmation from 'components/DeleteConfirmation';

const CommentOptions = ({ onEdit, onDelete }) => {
  const [opened, setOpened] = useState(false);
  const [deleteConfirmOpened, setDeleteConfirmOpened] = useState(false);

  const show = () => {
    setOpened(true);
  };

  const dismiss = () => {
    setOpened(false);
  };

  const removeComment = () => {
    onDelete();
    setDeleteConfirmOpened(false);
  };

  const renderOptions = () => {
    const handleEdit = () => {
      onEdit();
      dismiss();
    };

    const handleDelete = () => {
      setDeleteConfirmOpened(true);
      dismiss();
    };

    return (
      <>
        <button
          className={clsx(
            'button--unstyled',
            'button--menu',
          )}
          onClick={handleEdit}
        >
          Edit
        </button>
        <button
          className={clsx(
            'button--unstyled',
            'button--menu',
          )}
          onClick={handleDelete}
        >
          Delete
        </button>
      </>
    );
  };

  const trigger = (
    <DropdownButton className="button--unstyled button--options">
      <span className="fa fa-ellipsis-v" />
    </DropdownButton>
  );

  return (
    <>
      <APResponsiveDropdown
        opened={opened}
        show={show}
        dismiss={dismiss}
        triggerButton={trigger}
        placement="bottom-end"
        menuClass="comment-options-dropdown"
      >
        {renderOptions()}
      </APResponsiveDropdown>

      <DeleteConfirmation
        show={deleteConfirmOpened}
        handleClose={() => {
          setDeleteConfirmOpened(false);
        }}
        handleConfirm={removeComment}
        deleteText="Delete"
        size="xs"
      >
        <p>
          Deleting this comment will remove it permanently from this conversation.
          Any email notifications that have been sent won't be deleted.
        </p>
      </DeleteConfirmation>
    </>
  );
};

export default CommentOptions;
